import React from "react";
import { useNavigate } from "react-router-dom";



export default function RoughAvatarLink({
  to = "/about",
  imgSrc = "/images/responsive/den-256.webp",
  imgSrcSet = "/images/responsive/den-128.webp 128w, /images/responsive/den-256.webp 256w, /images/responsive/den-384.webp 384w",
  imgSizes = "(max-width: 768px) 90px, 101px",
  alt = "Denis Bitter",
  className = "",
  cropClassName = "object-[80%_20%]",
  ringColor = "#AC8E66",
  ringStrokeWidth = 0.7,
  priority = false,
  onClick,
}) {
  const navigate = useNavigate();

  const handleClick = (e) => {
    onClick?.(e);
    navigate(to);
    // sofort nach oben (dein Pattern)
    setTimeout(() => window.scrollTo({ top: 0, behavior: "instant" }), 0);
  };

  

  return (
    <div
      onClick={handleClick}
      className={`relative w-24 h-24 md:w-28 md:h-28 mx-auto mb-6 block cursor-pointer ${className}`}
      aria-label={`Zu ${to}`}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " " ? handleClick(e) : null)}
    >
      <div
        className="absolute inset-0 rounded-full"
        style={{ border: `${ringStrokeWidth}px solid ${ringColor}` }}
      />

      {/* Avatar */}
      <div className="absolute inset-2 rounded-full bg-gradient-to-br from-brand to-brand flex items-center justify-center overflow-hidden">
        <img
          src={imgSrc}
          srcSet={imgSrcSet}
          sizes={imgSizes}
          width={256}
          height={256}
          alt={alt}
          className={`w-full h-full object-cover ${cropClassName}`}
          loading={priority ? "eager" : "lazy"}
          fetchPriority={priority ? "high" : "auto"}
          decoding="async"
        />
      </div>
    </div>
  );
}
